import { cn } from 'utils/helpers'
import styles from './infoblock.module.scss'

export default function Infoblock({ children, type, className }) {
    return <div className={cn(styles.infoblock, styles[type], className)}>{children}</div>
}
